import React, {useEffect} from 'react';
import {Card, CardBody, CardTitle} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {connect, useSelector} from 'react-redux'

// components
import HotelCategoryForm from "./_form";
import HotelCategoryFilters from './_filters';
import TranslateButton from "../../../components/buttons/TranslateButton";
import GenericSwitch from "../../../components/genericComponents/genericSwitch";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";

// labels
import {
	LB_ACTIONS, LB_ACTIVE, LB_CODE,
	LB_EMPTY_TABLE, LB_PRIORITY, LIST,
} from "../../../components/i18n/i18n";
import { FL_TITLE } from "../../../components/i18n/formLabels";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

// actions
import { setFilter, setTableParams, changeListItem, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import { hotelCategoryService } from "../../../jwt/_services/hotel/hotelCategoryService";

// utils
import {getStateByPath} from "../../../redux/selectors";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";


const HotelCategoryList = props => {
	const {path} = props
	const componentState = useSelector(state => getStateByPath(state, path));
	const {userIsAdmin, app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};
	const fbDataBaseId = app?.fbDataBase?.id


	// Set initial filter
	useEffect(() => {
		if (!app?.id || !udn?.id || filter)
			return

		props.setFilter(path, {
			fbDataBase: { id: fbDataBaseId },
			item: { udn:{ id : udn?.id } }
		})
	}, [app, udn]);


	// Handle filter changer
	useEffect(() => {
		if (!filter)
			return

		genericIndexedActions.search(path, hotelCategoryService, pageIndex, pageSize, filter)
	}, [pageIndex, pageSize, filter]);


	const handleTableChange = (type, {page, sizePerPage}) => {
		let currentIndex = (page - 1) * sizePerPage
		props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
	};

	const handleStatusChange = (id, data, status) => genericIndexedActions.update(path, hotelCategoryService, id, {
		fbDataBase:  { id : fbDataBaseId },
		item: { ...data, status, id  }
	})

	const handleShowInHomeChange = (id, data, status) => genericIndexedActions.update(path, hotelCategoryService, id, {
		fbDataBase:  { id : fbDataBaseId },
		item: { ...data, showInHome:status, id  }
	})

	const editItem = data => {
		props.setItem(path, data);
		props.setForm(path, true, false, false);

		ModalFormContainer(HotelCategoryForm, { path, data })
	}

	const createItem = () => {
		props.setItem(path, null);
		props.setForm(path)
		ModalFormContainer(HotelCategoryForm, { path })
	}

	const confirmDelete = data => ConfirmDelete({
		path,
		data,
		fbDataBaseId,
		service: hotelCategoryService,
		remove: genericIndexedActions.delete,
	})

	const columns = [
		{
			dataField: 'id',
			headerStyle: {width: '0px'},
			text: 'ID',
			hidden: true
		}, {
			dataField: 'uid',
			text: 'UID',
			headerStyle: {width: '200px'},
			hidden: !userIsAdmin
		}, {
			dataField: 'code',
			text: `${LB_CODE}`,
			headerStyle: {width: '200px'},
			hidden: !userIsAdmin
		}, {
			dataField: 'title',
			text: `${FL_TITLE}`,
		}, {
			dataField: 'priority',
			text: `${LB_PRIORITY}`,
			headerAlign: 'center',
			align:'center',
			headerStyle: {width: '50px'},
		}, {
			dataField: 'status',
			text: `${LB_ACTIVE}`,
			headerAlign: 'center',
			align: 'center',
			headerStyle: {width: '50px'},
			formatter: (cell, row) => <GenericSwitch
				id={ row?.id }
				initialState={ row?.status }
				onChange={ handleStatusChange }
			/>
		}, {
			dataField: 'actions',
			isDummyField: true,
			text: `${LB_ACTIONS}`,
			headerAlign: 'center',
			align: 'center',
			headerStyle: {width: userIsAdmin ? '200px' : '50px'},
			formatter: (cell, row) => <>
				<GenericTableButton
					toolTip={TT_EDIT}
					icon={'fa-pen'}
					permission={'edit'}
					onClick={()=>editItem(row)}
				/>
				{ userIsAdmin && <TranslateButton item={row} service={ hotelCategoryService } path={path}/> }
				<GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
			</>
		}
	];

	return <Card>
		<CardTitle className="bg-light border-bottom p-3 mb-0">
			<i className="far fa-list-alt mr-2"> </i>{LIST}
			<div className="float-right">
				<GenericButton
					style={'table'}
					label={'Agregar'}
					toolTip={'Agregar'}
					icon={'fa-plus'}
					permission={'add'}
					onClick={createItem}
				/>
			</div>
		</CardTitle>

		<HotelCategoryFilters path={path}/>

		<CardBody className="">
			<BootstrapTable
				striped hover
				tableHeaderClass='mb-0'
				remote
				keyField="id"
				data={listDomainObjects || []}
				columns={columns}
				noDataIndication={LB_EMPTY_TABLE}
				pagination={paginationFactory({pageIndex, pageSize, totalSize})}
				onTableChange={handleTableChange}
			/>
		</CardBody>
	</Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
	setFilter,
	setTableParams,
	changeListItem,
	setForm,
	setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(HotelCategoryList)